<div class="wrapper">
  <div id="map" class="map-content demo-area"></div>
  <button
    (click)="
      updateLocation({
        lng: '-74.045524',
        lat: '4.7195894'
      })
    "
  >
    Update
  </button>
  <button
    (click)="
      updateLocationCluster({
        lng: '-74.0663847',
        lat: '4.6562963'
      })
    "
  >
    Update two
  </button>
  <button
    (click)="
      updateLocationCluster({
        lng: '-74.0542397',
        lat: '4.6943638'
      })
    "
  >
    Update three
  </button>
  <button
    (click)="
      updateLocationCluster({
        lng: '-74.0542397',
        lat: '4.6943638'
      })
    "
  >
    Update four
  </button>
</div>
